export default __webpack_public_path__ + "static/media/ProductsList_img4_En.03c77866.webp";